import profileLogoFull from './logo/logo-profile-software.svg';

type LogoFullProps = {
  className?: string;
};

const LogoFull = ({ className }: LogoFullProps) => {
  return <img src={profileLogoFull} className={className} alt="Profile Logo" />;
};

export default LogoFull;
